export const CHANGE_CURR_PAGE = 'change_curr_page'
export const CHANGE_ENTIRE_LIST = 'change_entire_list'
export const CHANGE_TOTAL_COUNT = 'change_total_count'
export const CHANGE_IS_LOADING = 'change_is_loading'